import React, { useEffect, useRef, useState } from "react";
import ScrollDateInput from "../../calendar/ScrollDateInput";

export default function EtapasCitatorioSection({
  fieldMeta,
  form,
  errors,
  submitting,
  modoRapido = false,
  setField,
  openCitatorioPicker,
  onCitatorioPicked,
  viewCitatorio,
  deleteCitatorio,
  citatorioInputRef,
}) {
  const [dragging, setDragging] = useState(false);

  const handleDragOver = (e) => { e.preventDefault(); e.stopPropagation(); setDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); e.stopPropagation(); setDragging(false); };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    const files = Array.from(e.dataTransfer.files);
    if (!files.length) return;
    onCitatorioPicked({ target: { files, value: "" } });
  };
  
function addBusinessDays(startDate, days) {
  if (!days || days <= 0) return "";

  const date = new Date(startDate + "T00:00:00");
  // NO contar el día inicial
  date.setDate(date.getDate() + 1);

  let added = 0;

  while (added < days) {
    const day = date.getDay();

    if (day !== 0 && day !== 6) {
      added++;
      if (added === days) break;
    }

    date.setDate(date.getDate() + 1);
  }

  // formateo LOCAL (no UTC)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
useEffect(() => {
  if (form.fecha_notificacion_demanda && form.dias_limite > 0) {
    const fechaCalculada = addBusinessDays(
      form.fecha_notificacion_demanda,
      form.dias_limite
    );
    setField("fecha_limite_contestacion", fechaCalculada);
  }
}, [form.fecha_notificacion_demanda, form.dias_limite]);
  const chip = (key, manual = false) => {
    if (manual) return <span className="oa-chip-manual">MANUAL</span>;
    const m = fieldMeta?.(key);
    if (!m) return null;
    if (m.needsReview) return <span className="oa-tag-review" title={m.reviewReason}><span className="material-symbols-outlined" style={{ fontSize: 11, verticalAlign: "middle" }}>warning</span> REVISAR</span>;
    if (m.isAI) return <span className="oa-chip-ai">IA</span>;
    return null;
  };
  const fw = (key) => `oa-field${fieldMeta?.(key)?.needsReview ? " oa-field-review" : ""}`;

  return (
    <section className="oa-card">
      <div className="oa-card-head">
        <h2 className="oa-card-title">
          <span className="oa-card-icon">
            <i className="fa-solid fa-calendar-days" />
          </span>
          TÉRMINOS Y PLAZOS
        </h2>
      </div>

      <div className="oa-card-body">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
           <div className={fw("fecha_notificacion_demanda")}>
              <label className="oa-label">
                <span className="oa-req">*</span> Fecha de Notificación de la Demanda {chip("fecha_notificacion_demanda")}
              </label>
              <ScrollDateInput
                value={form.fecha_notificacion_demanda || ""}
                onChange={(v) => setField("fecha_notificacion_demanda", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />
              {errors.fecha_notificacion_demanda ? (
                <div className="oa-error">{errors.fecha_notificacion_demanda}</div>
              ) : null}
            </div>
             <div className={fw("dias_limite")}>
  <label className="oa-label">
    <span className="oa-req">*</span> Días para Contestación {chip("dias_limite")}
  </label>
  <input
    className={`oa-input ${errors.dias_limite ? "oa-input-error" : ""}`}
    type="number"
    min="1"
    value={form.dias_limite || ""}
    onChange={(e) => {
      const val = Number(e.target.value);
      if (val > 0) setField("dias_limite", val);
    }}
    disabled={submitting}
  />
  {errors.dias_limite ? (
    <div className="oa-error">{errors.dias_limite}</div>
  ) : null}
</div>
            <div className="space-y-1">
    
              <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase">
                Fecha Límite Contestación {chip("fecha_limite_contestacion")}
              </label>
             <ScrollDateInput
  value={form.fecha_limite_contestacion || ""}
  disabled
  style={{ width: "100%" }}
/>
              {errors.fecha_limite_contestacion ? (
                <div className="oa-error">{errors.fecha_limite_contestacion}</div>
              ) : null}
            </div>

            {!modoRapido && (
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase">
                Fecha Audiencia Conciliatoria {chip("fecha_audiencia_conciliatoria")}
              </label>
              <ScrollDateInput
                value={form.fecha_audiencia_conciliatoria || ""}
                onChange={(v) => setField("fecha_audiencia_conciliatoria", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />
              {errors.fecha_audiencia_conciliatoria ? (
                <div className="oa-error">{errors.fecha_audiencia_conciliatoria}</div>
              ) : null}
            </div>
            )}

        

            {!modoRapido && <div className={fw("fecha_presentacion_demanda")}>
              <label className="oa-label">
                Fecha de Presentación de la Demanda {chip("fecha_presentacion_demanda")}
              </label>
              <ScrollDateInput
                value={form.fecha_presentacion_demanda || ""}
                onChange={(v) => setField("fecha_presentacion_demanda", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />
            </div>}
             {!modoRapido && <div className={fw("fecha_recepcion_demanda")}>
              <label className="oa-label">
                Fecha de Recepción de la Demanda en el Despacho {chip("fecha_recepcion_demanda")}
              </label>
              <ScrollDateInput
                value={form.fecha_recepcion_demanda || ""}
                onChange={(v) => setField("fecha_recepcion_demanda", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />

            </div>}
              {!modoRapido && <div className={fw("fecha_radicacion_demanda")}>
              <label className="oa-label">
                Fecha de Radicación de la Demanda {chip("fecha_radicacion_demanda")}
              </label>
              <ScrollDateInput
                value={form.fecha_radicacion_demanda || ""}
                onChange={(v) => setField("fecha_radicacion_demanda", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />

            </div>}
            {!modoRapido && <div className={fw("fecha_emision_citatorio")}>
              <label className="oa-label">
                Fecha de Emisión del Citatorio (CCL) {chip("fecha_emision_citatorio")}
              </label>
              <ScrollDateInput
                value={form.fecha_emision_citatorio || ""}
                onChange={(v) => setField("fecha_emision_citatorio", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />

            </div>}
             {!modoRapido && <div className={fw("fecha_constancia_conciliacion")}>
              <label className="oa-label">
                Fecha de Constancia de No Conciliación {chip("fecha_constancia_conciliacion")}
              </label>
              <ScrollDateInput
                value={form.fecha_constancia_conciliacion || ""}
                onChange={(v) => setField("fecha_constancia_conciliacion", v)}
                disabled={submitting}
                style={{ width: "100%" }}
              />

            </div>}
          </div>

          {!modoRapido && <div className="space-y-1">
            <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase">
              Observaciones de la Etapa Actual {chip("observaciones_etapa_actual", true)}
            </label>
            <textarea
              type="text"
              className={`oa-input ${errors.observaciones_etapa_actual ? "oa-input-error" : ""}`}
              value={form.observaciones_etapa_actual || ""}
              onChange={(e) => setField("observaciones_etapa_actual", e.target.value)}
              disabled={submitting}
              rows={6}
            />
            {errors.observaciones_etapa_actual ? (
              <div className="oa-error">{errors.observaciones_etapa_actual}</div>
            ) : null}
          </div>}

          {/* DEMANDA documentos — siempre visible (modo rápido y completo) */}
          <div className="mt-6">
            <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase block mb-2">
              Documentos de la Demanda
            </label>

            <div
              className={`oa-dropzone${dragging ? " oa-dropzone--dragging" : ""}`}
              onClick={openCitatorioPicker}
              onDragOver={handleDragOver}
              onDragEnter={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") openCitatorioPicker(); }}
            >
              <div className="oa-dropzone-ico">
                <span className="material-symbols-outlined oa-dropzone-ico-sym">
                  {dragging ? "file_download" : "attach_file"}
                </span>
              </div>
              <p className="oa-dropzone-title">
                {dragging
                  ? "Suelta los archivos aquí"
                  : Array.isArray(form.citatorio) && form.citatorio.length
                  ? `${form.citatorio.length} archivo(s) cargado(s) — clic o arrastra para agregar más`
                  : "Arrastra los archivos aquí o haz clic para seleccionar"}
              </p>
              <p className="oa-dropzone-sub">PDF, PNG, JPG — puedes agregar múltiples archivos de una misma demanda</p>
            </div>

            <input
              ref={citatorioInputRef}
              type="file"
              multiple
              accept=".pdf,.png,.jpg,.jpeg"
              style={{ display: "none" }}
              onChange={onCitatorioPicked}
            />

            {Array.isArray(form.citatorio) && form.citatorio.length ? (
              <div className="mt-3 flex flex-col gap-2">
                {form.citatorio.map((row) => (
                  <div key={row.id} className="flex items-center justify-between gap-2 bg-slate-50 dark:bg-slate-800/50 rounded px-3 py-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <span className="material-symbols-outlined text-slate-400" style={{ fontSize: 16 }}>
                        {row.filename?.match(/\.(png|jpg|jpeg)$/i) ? "image" : "picture_as_pdf"}
                      </span>
                      <span className="text-sm truncate" title={row.filename}>{row.filename}</span>
                    </div>
                    <div className="flex gap-2 flex-shrink-0">
                      <button type="button" className="oa-btn-lite" onClick={() => viewCitatorio(row)}>
                        <span className="material-symbols-outlined oa-btn-lite-ico">visibility</span>
                        Ver
                      </button>
                      <button type="button" className="oa-btn-lite oa-btn-lite-danger" onClick={() => deleteCitatorio(row.id)}>
                        <span className="material-symbols-outlined oa-btn-lite-ico">delete</span>
                        Quitar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
      </div>
    </section>
  );
}